var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("system", { attrs: { leftList: _vm.leftList } }),
      _vm._v(" "),
      _c("div", { staticClass: "pageBox" }, [
        _c(
          "div",
          { staticClass: "breadcrumb" },
          [
            _c(
              "el-breadcrumb",
              { attrs: { separator: "/" } },
              [
                _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                  _vm._v("首页"),
                ]),
                _vm._v(" "),
                _c("el-breadcrumb-item", [_vm._v("系统管理")]),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pageTabAdd" },
          [
            _c(
              "el-card",
              { staticClass: "box-card" },
              [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _c("el-page-header", {
                      attrs: {
                        content: _vm.editId == "" ? "新增账号" : "编辑账号",
                      },
                      on: { back: _vm.goBack },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form",
                  {
                    ref: "ruleForm",
                    staticClass: "demo-ruleForm",
                    attrs: {
                      model: _vm.ruleForm,
                      rules: _vm.rules,
                      "label-width": "100px",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "用户账号", prop: "account" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入用户账号" },
                          model: {
                            value: _vm.ruleForm.account,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "account", $$v)
                            },
                            expression: "ruleForm.account",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "用户密码", prop: "pass" } },
                      [
                        _c("el-input", {
                          attrs: {
                            "show-password": "",
                            placeholder: "请输入用户密码",
                          },
                          model: {
                            value: _vm.ruleForm.pass,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "pass", $$v)
                            },
                            expression: "ruleForm.pass",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "联系电话", prop: "tel" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入联系电话" },
                          model: {
                            value: _vm.ruleForm.tel,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "tel", $$v)
                            },
                            expression: "ruleForm.tel",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "角色", prop: "role" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { "margin-right": "auto" },
                            attrs: { placeholder: "请选择", clearable: "" },
                            model: {
                              value: _vm.ruleForm.role,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "role", $$v)
                              },
                              expression: "ruleForm.role",
                            },
                          },
                          _vm._l(_vm.ruleList, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.name, value: item.id },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "部门", prop: "department" } },
                      [
                        _c("el-cascader", {
                          staticStyle: { "margin-right": "auto" },
                          attrs: {
                            props: _vm.cateProps,
                            "show-all-levels": false,
                            options: _vm.departmentList,
                          },
                          on: { change: _vm.handleChange },
                          model: {
                            value: _vm.ruleForm.department,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "department", $$v)
                            },
                            expression: "ruleForm.department",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                        },
                        attrs: { label: "是否客服", prop: "select" },
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.ruleForm.select,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "select", $$v)
                              },
                              expression: "ruleForm.select",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: "1" } }, [
                              _vm._v("是"),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: "0" } }, [
                              _vm._v("否"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                        },
                        attrs: { label: "状态", prop: "select" },
                      },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.ruleForm.state,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "state", $$v)
                              },
                              expression: "ruleForm.state",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: "0" } }, [
                              _vm._v("正常"),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: "1" } }, [
                              _vm._v("冻结"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.ruleForm.nickName != ""
                      ? _c(
                          "el-form-item",
                          { attrs: { label: "客服昵称", prop: "name" } },
                          [
                            _c("el-input", {
                              attrs: {
                                disabled: "",
                                placeholder: "请输入客服昵称",
                              },
                              model: {
                                value: _vm.ruleForm.nickName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.ruleForm, "nickName", $$v)
                                },
                                expression: "ruleForm.nickName",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "用户名称", prop: "name" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入用户名称" },
                          model: {
                            value: _vm.ruleForm.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "name", $$v)
                            },
                            expression: "ruleForm.name",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "email", prop: "email" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入email" },
                          model: {
                            value: _vm.ruleForm.email,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "email", $$v)
                            },
                            expression: "ruleForm.email",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.close()
                              },
                            },
                          },
                          [_vm._v("取消")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "btn",
                            staticStyle: { "margin-right": "auto" },
                            on: {
                              click: function ($event) {
                                return _vm.submitForm("ruleForm")
                              },
                            },
                          },
                          [_vm._v("保存")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }